module.exports = __webpack_public_path__ + "img/xiang.9f4b4fe7.gif";